<div class="row protean-info selectable mt-2 col-md-12 col-12">
    <div cdkDropList class="card-container" (cdkDropListDropped)="drop($event)">
        <div *ngFor="let card of allCards" cdkDrag [cdkDragData]="card" class="card-wrapper"
            [ngClass]="{'d-none': !cardVisibility[card]}">

            <div style="display: flex; flex-direction: row; gap: 10px;">
            </div>


            <div class="col-md-12 col-12">

                <div [ngClass]="{'card': true, 'mt-1': true}" *ngIf="cardVisibility[card]" cdkDragHandle>
                <div style="display: flex; align-items: center; padding: 0; border-bottom: 0;"
                    cdkDragHandle>
                    <div class="drag-handle mr-2">
                        <i class="fa fa-bars"></i>
                    </div>
                    <div *ngIf="card === 'physical'">
                        <!-- <div class="card"> -->
                        <div class="card-body">
                            <div class="widget-container fluid-height">

                                <div class="heading">
                                    <span class="fa-stack title-icon" icon="fa fa-location-arrow"
                                        style="color: #cf00be;">
                                        <i class="auto fa fa-square fa-stack-2x"></i>
                                        <i class="auto fa-stack-1x fa-inverse fa fa-location-arrow"></i>
                                    </span>&nbsp;
                                    <span>{{"Physical Device" | translate}}</span>
                                    <div class="pull-right">
                                        <!-- ios change  -->
                                        <button ng-click='device.platform=="iOS" ? press("finder") : finder()'
                                            (click)="control.identify()" class="btn btn-light find-device">
                                            <i class="fa fa-info"></i>&nbsp;
                                            <span>{{"Find Device" | translate}}</span>
                                        </button>
                                        <!-- ios change  -->
                                    </div>
                                </div>
                                <div class="widget-content">
                                    <table class="table table-condensed table-hover table-infocard">
                                        <tbody>
                                            <tr>
                                                <td>{{"Place" | translate}}</td>
                                                <td>{{device.provider.name}}</td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="card === 'display'">
                        <!-- <div class="card mt-1"> -->
                        <div class="card-body">
                            <div class="widget-container fluid-height">

                                <div class="heading">
                                    <span class="fa-stack title-icon" icon="fa fa-tablet" style="color: #1e87ff;">
                                        <i class="auto fa fa-square fa-stack-2x"></i>
                                        <i class="auto fa-stack-1x fa-inverse fa fa-tablet"></i></span>&nbsp;
                                    <span>{{"Display" | translate}}</span>
                                </div>
                                <div class="widget-content padded-small blocktext">
                                    <table class="table table-condensed table-hover table-infocard">
                                        <tbody>
                                            <tr>
                                                <td>{{"Size" | translate}}</td>
                                                <td *ngIf="!device.ios">{{device.display.height+ "X" +
                                                    device.display.width}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>{{"Density" | translate}}</td>
                                                <td>{{device.display.density}}</td>
                                            </tr>
                                            <tr>
                                                <td>{{"FPS" | translate}}</td>
                                                <td>{{device.display.fps}}</td>
                                            </tr>
                                            <tr>
                                                <td>{{"Width" | translate}}</td>
                                                <td *ngIf="!device.ios">{{device.display.width}} px</td>
                                            </tr>
                                            <tr>
                                                <td>{{"Height" | translate}}</td>
                                                <td *ngIf="!device.ios">{{device.display.height}} px</td>
                                            </tr>
                                            <tr>
                                                <td>{{"ID" | translate}}</td>
                                                <td>{{device.display.id}}</td>
                                            </tr>
                                            <tr>
                                                <td>{{"Orientation" | translate}}</td>
                                                <td>{{device.display.rotation}}°</td>
                                            </tr>
                                            <tr>
                                                <td>{{"Encrypted" | translate}}</td>
                                                <td>{{device.display.secure | deviceStatus: 'humanizedBool'}}</td>
                                            </tr>
                                            <tr>
                                                <td>{{"X DPI" | translate}}</td>
                                                <td>{{device.display.xdpi}}</td>
                                            </tr>
                                            <tr>
                                                <td>{{"Y DPI" | translate}}</td>
                                                <td>{{device.display.ydpi}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="card === 'platform'">
                        <!-- <div class="card mt-1"> -->
                        <div class="card-body">
                            <div class="widget-container fluid-height">

                                <div class="heading">
                                    <span class="fa-stack title-icon" icon="fa fa-mobile" style="color: #27cdff;">
                                        <i class="auto fa fa-square fa-stack-2x"></i>
                                        <i class="auto fa-stack-1x fa-inverse fa fa-mobile"></i>
                                    </span>&nbsp;
                                    <span>{{"Platform" | translate}}</span>
                                </div>
                                <div class="widget-content padded-small blocktext">
                                    <table class="table table-condensed table-hover table-infocard">
                                        <tbody>
                                            <tr>
                                                <td>{{"OS" | translate}}</td>
                                                <td>{{device.platform}}</td>
                                            </tr>
                                            <tr>
                                                <td>{{"Version" | translate}}</td>
                                                <td *ngIf="!device.ios">{{device.version}}</td>
                                            </tr>
                                            <tr>
                                                <td>{{"SDK" | translate}}</td>
                                                <td>{{device.sdk}}</td>
                                            </tr>
                                            <tr>
                                                <td>{{"ABI" | translate}}</td>
                                                <td *ngIf="!device.ios">{{device.abi}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="card === 'memory'">
                        <!-- <div class="card mt-1"> -->
                        <div class="card-body">
                            <div class="widget-container fluid-height">

                                <div class="heading">
                                    <span class="fa-stack title-icon" icon="fa fa-database">
                                        <i class="auto fa fa-square fa-stack-2x color-orange"></i>
                                        <i class="auto fa-stack-1x fa-inverse fa fa-database"></i></span>&nbsp;
                                    <span>{{"Memory" | translate}}</span>
                                </div>
                                <div class="widget-content padded-small blocktext">
                                    <table class="table table-condensed table-hover table-infocard">
                                        <tbody>
                                            <tr>
                                                <td>{{"RAM" | translate}}</td>
                                                <td *ngIf="!device.ios">{{'-'}}</td>
                                            </tr>
                                            <tr>
                                                <td>{{"ROM" | translate}}</td>
                                                <td>{{'-'}}</td>
                                            </tr>
                                            <tr>
                                                <td>{{"SD Card Mounted" | translate}}</td>
                                                <td>{{ sdCardMounted | deviceStatus: 'humanizedBool' }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-12 col-12">
                    <!-- <div [ngClass]="{'card': true, 'mt-1': true}" *ngIf="cardVisibility[card]">
                <div style="display: flex; align-items: center; padding: 0; border-bottom: 0;" cdkDragHandle> -->
                    <div class="drag-handle mr-2">
                        <i class="fa fa-bars"></i>
                    </div>
                    <div *ngIf="card === 'battery'">
                        <!-- <div class="card"> -->
                        <div class="card-body">
                            <div class="widget-container fluid-height">

                                <div class="heading">
                                    <span class="fa-stack title-icon" icon="fa fa-bolt" style="color: #ffe81e;"> <i
                                            class="auto fa fa-square fa-stack-2x"></i>
                                        <i class="auto fa-stack-1x fa-inverse fa fa-bolt"></i></span>&nbsp;
                                    <span>{{"Battery" | translate}}</span>
                                </div>
                                <div class="widget-content padded-small blocktext">
                                    <table class="table table-condensed table-hover table-infocard">
                                        <tbody>
                                            <!-- ios change -->
                                            <tr *ngIf="!device.ios">
                                                <td>{{"Health" | translate}}</td>
                                                <td>{{device.battery.health | deviceStatus: 'batteryHealth'}}</td>
                                            </tr>
                                            <tr *ngIf="!device.ios">
                                                <td>{{"Power Source" | translate}}</td>
                                                <td>{{device.battery.source | deviceStatus : 'batterySource'}}</td>
                                            </tr>
                                            <tr *ngIf="!device.ios">
                                                <td>{{"Status" | translate}}</td>
                                                <td>{{device.battery.status | deviceStatus : 'batteryStatus'}}</td>
                                            </tr>
                                            <tr *ngIf="!device.ios">
                                                <td>{{"Level" | translate}}</td>
                                                <td>
                                                    <div class="progress">
                                                        <div class="progress-bar" role="progressbar"
                                                            [ngStyle]="{ 'width.%': device.battery.level,'background-color': device.battery.level > 20 ? 'green' : 'red' }"
                                                            aria-valuemin="0" aria-valuenow="device.battery.level"
                                                            aria-valuemax="device.battery.scale">
                                                            {{ device.battery.level / device.battery.scale * 100 }}%
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr *ngIf="!device.ios">
                                                <td>{{"Temperature" | translate}}</td>
                                                <td>{{device.battery.temp}} °C</td>
                                            </tr>
                                            <tr *ngIf="!device.ios">
                                                <td>{{"Voltage" | translate}}</td>
                                                <td>{{device.battery.voltage}} v</td>
                                            </tr>
                                            <!-- ios change -->
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="card === 'network'">
                        <!-- <div class="card mt-1"> -->
                        <div class="card-body">
                            <div class="widget-container fluid-height">

                                <div class="heading">
                                    <span class="fa-stack title-icon" icon="fa fa-signal" style="color: #c96b00;">
                                        <i class="auto fa fa-square fa-stack-2x color-brown"></i>
                                        <i class="auto fa-stack-1x fa-inverse fa fa-signal"></i>
                                    </span>&nbsp;
                                    <span>{{"Network" | translate}}</span>
                                </div>
                                <div class="widget-content padded-small blocktext">
                                    <table class="table table-condensed table-hover table-infocard">
                                        <tbody>
                                            <tr *ngIf="!device.ios">
                                                <td>{{"Connected" | translate}}</td>
                                                <td>{{device.network.connected | deviceStatus: 'humanizedBool'}}</td>
                                            </tr>
                                            <tr>
                                                <td>{{"Airplane Mode" | translate}}</td>
                                                <td *ngIf="!device.ios">{{device.airplaneMode | deviceStatus:
                                                    'humanizedBool'}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>{{"Using Fallback" | translate}}</td>
                                                <td *ngIf="!device.ios">{{device.network.failover | deviceStatus:
                                                    'humanizedBool'}}</td>
                                            </tr>
                                            <tr>
                                                <td>{{"Roaming" | translate}}</td>
                                                <td *ngIf="!device.ios">{{device.network.roaming | deviceStatus:
                                                    'humanizedBool'}}</td>
                                            </tr>
                                            <tr>
                                                <td>{{"Type" | translate}}</td>
                                                <td *ngIf="!device.ios">{{device.network.type | deviceStatus:
                                                    'networkType'}}
                                                </td>
                                            </tr>
                                            <!-- <tr>
                                        <td>Sub Type</td>
                                        <td>{{device.network.subtype | deviceStatus: 'networkSubType'}}</td>
                                    </tr> -->
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="card === 'hardware'">
                        <!-- <div class="card mt-1"> -->
                        <div class="card-body">
                            <div class="widget-container fluid-height">

                                <div class="heading">
                                    <span class="fa-stack title-icon" icon="fa fa-phone" style="color: #54ff20;">
                                        <i class="auto fa fa-square fa-stack-2x"></i>
                                        <i class="auto fa-stack-1x fa-inverse fa fa-phone"></i>
                                    </span>&nbsp;
                                    <span>{{"Hardware" | translate}}</span>
                                </div>
                                <div class="widget-content padded-small blocktext">
                                    <table class="table table-condensed table-hover table-infocard">
                                        <tbody>
                                            <tr>
                                                <td>{{"Manufacturer" | translate}}</td>
                                                <td>{{device.ios ? device.deviceType : device.manufacturer}}</td>
                                            </tr>
                                            <tr>
                                                <td>{{"Product" | translate}}</td>
                                                <td>{{device.ios ? device.deviceType : device.name}}</td>
                                            </tr>
                                            <tr>
                                                <td>{{"Model" | translate}}</td>
                                                <td>{{device.model}}</td>
                                            </tr>
                                            <tr>
                                                <td>{{"Serial" | translate}}</td>
                                                <td>{{device.serial}}</td>
                                            </tr>
                                            <tr>
                                                <td>{{"Released" | translate}}</td>
                                                <td *ngIf="!device.ios">{{device.releasedAt ? (device.releasedAt) :
                                                    '-'}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="card === 'cpu'">
                        <!-- <div class="card mt-1"> -->
                        <div class="card-body">
                            <div class="widget-container fluid-height">

                                <div class="heading">
                                    <span class="fa-stack title-icon" icon="fas fa-microchip">
                                        <i class="auto fa fa-square fa-stack-2x" style="color: #000000;"></i>
                                        <i class="auto fa-stack-1x fa-inverse fas fa-microchip"></i>
                                    </span>&nbsp;
                                    <span>{{"CPU" | translate}}</span>
                                </div>
                                <div class="widget-content padded-small blocktext">
                                    <table class="table table-condensed table-hover table-infocard">
                                        <tbody>
                                            <tr>
                                                <td>{{"Name" | translate}}</td>
                                                <td>{{device.cpu?.name || '-'}}</td>
                                            </tr>
                                            <tr>
                                                <td>{{"Cores" | translate}}</td>
                                                <td>{{device.cpu?.cores ? device.cpu?.cores : '-'}}</td>
                                            </tr>
                                            <tr>
                                                <td>{{"Total" | translate}}</td>
                                                <td *ngIf="totalMem">{{totalMem}}</td>
                                            </tr>
                                            <tr>
                                                <td>{{"Used" | translate}}</td>
                                                <td>{{usedMemory}}</td>
                                            </tr>
                                            <tr>
                                                <td>{{"Free" | translate}}</td>
                                                <td>{{freeMemory}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>